const getDeliveryLocationDrawerDataProps = (moduleSettings) => {
  return moduleSettings.map((ms) => {
    var _a;
    const composableWindowMap = ((_a = ms.composable_window) == null ? void 0 : _a.reduce(
      (composableWindowMap2, composableWindowObj) => {
        var _a2, _b;
        const developmentFieldKey = (_a2 = composableWindowObj == null ? void 0 : composableWindowObj.text_only) == null ? void 0 : _a2.development_field_key;
        composableWindowMap2[developmentFieldKey] = (_b = composableWindowObj == null ? void 0 : composableWindowObj.text_only) == null ? void 0 : _b.body;
        return composableWindowMap2;
      },
      {}
    )) || {};
    return {
      closeButtonAriaLabel: composableWindowMap["closeButtonAriaLabel"],
      backButtonAriaLabel: composableWindowMap["backButtonAriaLabel"],
      description: composableWindowMap["drawerBody"],
      NDEnabledDescription: composableWindowMap["NDEnabledDrawerBody"],
      confirmationTemplate: composableWindowMap["confirmationTemplate"],
      inputTitle: composableWindowMap["inputFieldLabel"],
      invalidInputErrorMessage: composableWindowMap["inputError"],
      serviceDownErrorMessage: composableWindowMap["serviceError"],
      buttonLabel: composableWindowMap["buttonLabel"],
      title: composableWindowMap["drawerTitle"],
      drawerSubtitle: composableWindowMap["drawerSubtitle"],
      helperText: composableWindowMap["helperText"],
      deliveryNotAvailable: composableWindowMap["deliveryNotAvailable"],
      enterFullDeliveryAddress: composableWindowMap["enterFullDeliveryAddress"],
      deliveryToLimitedAreas: composableWindowMap["deliveryToLimitedAreas"],
      validationSchemaType: ms.locale,
      // Specific for Delivery Address Form Component
      streetAddressInputLabel: composableWindowMap["streetAddressInputLabel"],
      aptSuiteUnitEtcInputField: composableWindowMap["aptSuiteUnitEtcInputField"],
      zipcodeInputLabel: composableWindowMap["zipcodeInputLabel"],
      errorNoMatchForAddress: composableWindowMap["errorNoMatchForAddress"],
      serviceError: composableWindowMap["serviceError"],
      optionalLabelText: composableWindowMap["optionalLabelText"],
      errorMsgInputValidZipCodeText: composableWindowMap["errorMsgInputValidZipCodeText"],
      errorMsgInputValidAddrText: composableWindowMap["errorMsgInputValidAddrText"],
      addressLine1LabelText: composableWindowMap["addressLine1LabelText"],
      addressLine2LabelText: composableWindowMap["addressLine2LabelText"]
    };
  });
};
function replaceStringTemplate(stringWithTemplates, replacementMap) {
  let newString = stringWithTemplates;
  Object.keys(replacementMap).forEach((key) => {
    newString = newString.replaceAll(`{{${key}}}`, replacementMap[key]);
  });
  return newString;
}
function encodeAddressInfo(values) {
  const addressArray = [values];
  return encodeURIComponent(JSON.stringify(addressArray));
}
export {
  encodeAddressInfo,
  getDeliveryLocationDrawerDataProps,
  replaceStringTemplate
};
